module.exports = __webpack_public_path__ + "static/media/twitter.ac042332.svg";